module.exports = __webpack_public_path__ + "media/IBMPlexSans-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Bold.ttf
// module id = 1322
// module chunks = 62